import { render, staticRenderFns } from "./AudioElement.vue?vue&type=template&id=21418957&scoped=true&"
import script from "./AudioElement.vue?vue&type=script&lang=ts&"
export * from "./AudioElement.vue?vue&type=script&lang=ts&"
import style0 from "./AudioElement.vue?vue&type=style&index=0&id=21418957&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21418957",
  null
  
)

export default component.exports